import React from "react";

interface SIMPLCheckBoxProps {
  id: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  required?: boolean;
  hideLabel?: boolean;
  errorLabel?: boolean;
  fontWeight?: string;
  onChange?: (checked: boolean) => void;
  testId?:string
}

export const SIMPLCheckBox: React.FC<SIMPLCheckBoxProps> = ({
  id,
  label,
  checked = false,
  disabled = false,
  required = false,
  hideLabel = false,
  errorLabel = false,
  fontWeight = "bold",
  onChange,
  testId
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
  };

  const fontWeightClass = (w: string) => {
    switch (w) {
      case "bold":
        return "font-bold";
      case "medium":
        return "font-medium";
      default:
        return "font-normal";
    }
  };

  return (
    <div className="flex flex-col mb-4">
      {!hideLabel && (
        <label
          htmlFor={id}
          className={`inline-block mb-1 text-sm cursor-pointer ${fontWeightClass(
            fontWeight
          )} ${errorLabel ? "text-red-500" : "text-gray-800"}`}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <label className={`flex items-center cursor-pointer select-none text-sm ${fontWeightClass('bold')}`}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          className="hidden"
          data-test-id={testId}
        />

        {/* BIGGER CHECKBOX */}
        <div
          className={`
            w-6 h-6 rounded-sm border flex items-center justify-center
            ${checked ? "bg-fuchsia-600 border-fuchsia-600" : "border-gray-400"}
          `}
        >
          {checked && (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </label>
    </div>
  );
};
